import { PostCustomQuestion } from "./ApiCalls/customQuestion/postCustomQuestion";
import { PatchCustomQuestion } from "./ApiCalls/customQuestion/patchCustomQuestion";
import { GetCustomQuestions } from "./ApiCalls/customQuestion/getCustomQuestions";
import { GetCustomQuestionsIncident } from "./ApiCalls/customQuestion/getCustomQuestionsIncident";
import { DisableCustomQuestionGroup } from "./ApiCalls/customQuestion/disableCustomQuestionGroup";
import { DisableCustomQuestion } from "./ApiCalls/customQuestion/disableCustomQuestion";
import Cookies from "js-cookie";

const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const modifiedBy = authInfo.idUser;


export async function GetCustomQuestionsService(company) {
  try {
    const customQuestions = await GetCustomQuestions(company);

    const CustomQuestionsData = customQuestions.map((customQuestion) => ({
      title: customQuestion.title,
      customQuestion: customQuestion.customQuestion1,
      company: customQuestion.company,
      questionGroup: customQuestion.questionGroup,
      language: customQuestion.language,
      createdAt: customQuestion.createdAt,
      enabled: customQuestion.enabled,
    }));

    return CustomQuestionsData;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function GetCustomQuestionsIncidentService(company) {
  const language = Cookies.get('myreportin_language')
  const customQuestions = await GetCustomQuestionsIncident(company, language);

  const CustomQuestionsData = customQuestions.map((customQuestion) => ({
    title: customQuestion.title,
    customQuestion: customQuestion.customQuestion1,
    company: customQuestion.company,
    questionGroup: customQuestion.questionGroup,
    language: customQuestion.language,
    createdAt: customQuestion.createdAt,
    enabled: customQuestion.enabled,
  }));

  return CustomQuestionsData;
}

export async function PostCustomQuestionService(customQuestion) {
  try {
    const customQuestions = await PostCustomQuestion(customQuestion, modifiedBy);

    return customQuestions;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function PatchCustomQuestionService(
  customQuestionId,
  customQuestion
) {
  try {
    const customQuestions = await PatchCustomQuestion(
      customQuestionId,
      customQuestion,
      modifiedBy
    );

    return customQuestions;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function DisableCustomQuestionService(
  customQuestion,
  customQuestionId
) {
  try {
    const customQuestions = await DisableCustomQuestion(
      customQuestion,
      customQuestionId,
      modifiedBy
    );

    return customQuestions;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function DisableCustomQuestionGroupService(
  customQuestionGroup
) {

  try {
    const customQuestions = await DisableCustomQuestionGroup(

      customQuestionGroup,
      modifiedBy
    );

    return customQuestions;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}